<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-form-group>
            <label class="form-control-label">
              {{ $t('views.exsborder.form.firm') }}:
            </label>
            <base-select-input
              v-model="filters.firm"
              :search-callback="userDataSearchCallback"
              :query-param="'userdata'"
              :display-values="['fullName', 'firmname1']"
              :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
            ></base-select-input>
          </b-form-group>
        </b-col>
        <b-col>
          <label class="form-control-label">
            {{ $t('views.excmcasetype.form.enablePartner') }}:
          </label>
          <base-select-input
            v-model="filters.contractor"
            :search-callback="partnerSearchCallback"
            :query-param="'userdata'"
            :display-values="['fullName', 'firmname1']"
            :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
          ></base-select-input>
        </b-col>
        <b-col>
          <label
            class="form-control-label">{{ $t('views.excmnote.form.idCase') }}
          </label>
          <BaseSelectInput
            ref="caseInput"
            v-model="filters.idCase"
            :search-callback="caseSearchCallback"
            :display-values="['title', 'contractorUserData.fullName', 'contractorUserData.firmname1']"
            :query-param="'contractor'"
            :placeholder-autocomplete="'Zacznij wpisywać kontrahenta'"
            :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
          ></BaseSelectInput>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <b-form-group>
            <label class="form-control-label">{{ $t('views.exsborder.list.filters.idOrderStatus') }}:</label>
            <el-select
              v-model="filters.orderStatus"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder=""
              :remote-method="remoteMethod"
              :loading="loading">
              <el-option
                v-for="item in orderStatuses"
                :key="item['@id']"
                :label="item.name"
                :value="getIdLink(item['@id'])">
              </el-option>
            </el-select>
          </b-form-group>
        </b-col>
        <b-col cols="4" v-if="orderTagOptions.length > 0">
          <b-form-group>
            <label>{{$t("views.exsborder.form.tags")}}: </label>
            <multi-select :options="orderTagOptions" :selected-options="tagsFilter" @select="onSelectTags" >
            </multi-select>
          </b-form-group>
        </b-col>
        <b-col v-else cols="4"></b-col>
        <b-col cols="1">
          <label class="form-control-label">{{ $t('views.firm.list.filters.state') }}:</label>
          <b-form-group>
            <b-form-radio-group
              v-model="filters.state"
              :options="radioOptions"
              buttons
              button-variant="outline-primary"
              name="radios-btn-default"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <label class="form-control-label">{{ $t('views.exsborder.list.completed') }}:</label>
          <b-form-group>
            <b-form-radio-group
              v-model="filters.completed"
              :options="radioOptionsAll"
              buttons
              button-variant="outline-primary"
              name="radios-btn-default"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <label class="form-control-label">{{ $t('views.exsborder.list.priced') }}:</label>
          <b-form-group>
            <b-form-radio-group
              v-model="filters.priced"
              :options="radioOptionsAll"
              buttons
              button-variant="outline-primary"
              name="radios-btn-default"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
import getId from '@/utils/getIdFromLink'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { mapActions } from 'vuex'
import { MultiSelect } from 'vue-search-select'
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'

export default {
  name: 'OrdersFiltering',
  components: { BaseSelectInput, MultiSelect },
  data () {
    return {
      radioOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      radioOptionsAll: [
        {
          value: '',
          text: this.$t('menu.agreements.listAll')
        },
        {
          value: 1,
          text: this.$t('buttons.yes')
        },
        {
          value: 0,
          text: this.$t('buttons.no')
        }
      ],
      orderTagOptions: [],
      delay: 500,
      filters: {
        state: 1,
        orderStatus: null,
        firm: '',
        idCase: '',
        contractor: '',
        'orderTags.tag': [],
        completed: '',
        priced: ''
      },
      tagsFilter: [],
      orderStatuses: [],
      firms: [],
      loading: false
    }
  },

  directives: {
    debounce
  },

  watch: {
    filters: {
      deep: true,
      handler () {
        this.filter()
      }
    }
  },

  created () {
    this.getOrderStatuses()
    this.getFirms()
    this.fetchOrderTagOptions()
  },

  methods: {
    ...mapActions({
      getPage: 'exsborder/list/default'
    }),
    filter () {
      let link = addParamsToQuery('e_x_s_b_orders', JSON.parse(JSON.stringify(this.filters)))
      this.getPage(link)
    },
    async getFirms () {
      let params = {
        'pagination': false,
        'state': 1,
        'isContractor': 1
      }
      const response = await new ApiService('user_datas/list', params).getResults()
      this.firms = response.items
    },

    async getOrderStatuses () {
      let params = {
        'pagination': false,
        'state': 1
      }
      const response = await new ApiService('e_x_s_b_order_statuses', params).getResults()
      this.orderStatuses = response.items
    },
    async caseSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_c_m_cases', baseParams).getResults()
      return response.items
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isContractor: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async partnerSearchCallback (params = {}) {
      let baseParams = { pagination: false, isCompany: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async fetchOrderTagOptions () {
      let baseParams = { pagination: false, tagType: 4 }
      const response = await new ApiService('e_x_c_m_tags', baseParams).getResults()
      this.orderTagOptions = response.items.map(tag => {
        return {
          value: tag['@id'],
          text: tag.tag
        }
      })
    },
    onSelectTags (items, lastSelectItem) {
      this.filters['orderTags.tag'] = items.map(item => {
        return item.value
      })
      this.tagsFilter = items
      this.lastSelectTag = lastSelectItem
    },
    remoteMethod () {
      // console.log()
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
